import { API_URLS, API_METHOD } from '../../config/apiUrl';
import request from '../../helpers/requests';
import URLS from '../../helpers/urls';

export async function insert(payload) {
    return await request("POST", `${process.env.REACT_APP_DEV_API_URL}${API_URLS.plusLead.insert}`, null, payload, null)
}

export async function scheduleSiteVisit(payload) {
    return await request("POST", `${process.env.REACT_APP_DEV_API_URL_V2}${API_URLS.plusLead.scheduleSiteVisit}`, null, payload, null)
}

export async function rescheduleSiteVisit(uuid, payload) {
    return await request("PUT", `${process.env.REACT_APP_DEV_API_URL_V2}${API_URLS.plusLead.rescheduleSiteVisit}/${uuid}`, null, payload, null)
}
export async function getBrokerSiteVisit(uuid) {
    return await request(API_METHOD.GET, `${process.env.REACT_APP_DEV_API_URL}${API_URLS.plusLead.getBrokerSiteVisit}/${uuid}`, null, null, null)
}

export async function getTimeline(uuid) {
    return await request(API_METHOD.GET, `${process.env.REACT_APP_DEV_API_URL}${API_URLS.plusLead.getTimeline}/${uuid}`, null, null, null)
}

export async function getAllSitevisit(searchText, tab, payload) {
    return await request(API_METHOD.POST, `${process.env.REACT_APP_DEV_API_URL}${API_URLS.plusLead.getAllSitevisit}`, { searchText, tab }, payload, null)
}

export async function reSchedule(uuid, payload) {
    return await request(API_METHOD.PUT, `${process.env.REACT_APP_DEV_API_URL}${API_URLS.plusLead.reSchedule}/${uuid}`, null, payload, null)
}

export async function tokenRequest(payload) {
    return await request(API_METHOD.PUT, `${process.env.REACT_APP_DEV_API_URL}${API_URLS.plusLead.tokenRequest}`, null, payload, null)
}


export async function getCompanyName(name) {
    return await request(API_METHOD.GET, `${process.env.REACT_APP_DEV_API_URL}${API_URLS.plusLead.getCompanyName}/${name}`, null, null, null)
}

// Plus setting apis

export async function getUsersForSettings() {
    return await request(API_METHOD.GET, `${process.env.REACT_APP_DEV_API_URL}${API_URLS.plusSettings.getUsersForSettings}`, null, null, null)
}

export async function getUsers() {
    return await request(API_METHOD.GET, `${process.env.REACT_APP_DEV_API_URL}${API_URLS.plusSettings.getUsers}`, null, null, null)
}
export async function inviteUserViaEmail(payload) {
    return await request(API_METHOD.POST, `${process.env.REACT_APP_DEV_API_URL}${API_URLS.plusSettings.inviteUserViaEmail}`, null, payload, null)
}

export async function approveUserRequest(payload) {
    return await request(API_METHOD.POST, `${process.env.REACT_APP_DEV_API_URL}${API_URLS.plus_company.approveUserRequest}`, null, payload, null)
}